import { isNumber } from 'lodash-es'
import { ReactNode } from 'react'

import { cn, createSlot } from '@/shared/lib'

import { ProgressBar } from './progress-bar'

type CommonProps = {
  children: ReactNode
  progress?: number
  className?: string
  innerClassName?: string
}

export const Card = ({
  children,
  progress,
  className,
  innerClassName,
}: CommonProps) => {
  const { slots } = createSlot(children, [
    'icon',
    'title',
    'description',
    'children',
    'subContent',
  ])

  const showProgressBar = isNumber(progress)

  return (
    <section
      className={cn(
        'relative rounded-sm bg-white shadow-[0px_1px_7px_0px_rgba(0,0,0,0.15)]',
        className,
      )}
    >
      {showProgressBar && <ProgressBar progress={progress} />}
      <div
        className={cn(
          'px-10 py-15',
          showProgressBar && 'pt-16',
          innerClassName,
        )}
      >
        <div className="mb-15 space-y-4">
          {slots.icon}
          {slots.title && (
            <h1 className={cn('typo-title2 font-semibold text-black')}>
              {slots.title}
            </h1>
          )}
          {slots.description && (
            <p
              className={cn(
                'typo-label1 mt-4 whitespace-break-spaces text-gray-600',
              )}
            >
              {slots.description}
            </p>
          )}
        </div>
        {slots.children}
      </div>
      {slots.subContent && (
        <div className="bg-gray-50 px-10 py-15">{slots.subContent}</div>
      )}
    </section>
  )
}
